import React from "react";
import styled from "styled-components";

const StyleSubLabel = styled.p`
  margin-bottom: 0;
  justify-self: flex-start;
  font-size: 12px;
  text-align: right;
  color: rgba(0, 0, 0, 0.5);
`;

const SubLabel = (props) => {
  const { className, children } = props;

  if (!children) {
    return null;
  }

  return <StyleSubLabel className={className}>{children}</StyleSubLabel>;
};

export default SubLabel;
